// Multi-tenancy: helper to read the `role` claim from the stored JWT.
// localStorage("role") holds companyType/userType strings (see OtpSaga/ProfileSaga),
// NOT the numeric role claim, so the super-admin check (role === 99) must decode
// the token payload. Plain base64url decode — no extra library needed.
// NOTE: this is a UI convenience gate only; the API's role-99 check is the
// actual security wall.

export const SUPER_ADMIN_ROLE = 99;

// Decode an arbitrary JWT's payload (borrow-a-seat needs to peek at the
// stashed platform token, not only the active one).
export const decodeJwt = (token) => {
  try {
    if (!token || token === "undefined") return null;
    const payloadSegment = token.split(".")[1];
    if (!payloadSegment) return null;
    const base64 = payloadSegment.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(window.atob(base64));
  } catch (e) {
    return null;
  }
};

export const getJwtPayload = () => {
  try {
    return decodeJwt(localStorage.getItem("token"));
  } catch (e) {
    return null;
  }
};

export const isSuperAdmin = () => {
  const payload = getJwtPayload();
  return Number(payload?.role) === SUPER_ADMIN_ROLE;
};

// Borrow-a-seat: true while the active token is an assumed tenant token
// (claims assumed:true, assumedBy:<super admin>). Note the assumed token's
// role is the borrowed tenant role, NOT 99 — gate assumed-mode UI on this,
// never on isSuperAdmin().
export const isAssumed = () => getJwtPayload()?.assumed === true;
